// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/view/settings/MenuWorkConfig/Item.css
// module id = 2042
// module chunks = 0